export const templates = [
    {
        value: 'black-hat-report-v1',
        label: 'Black Hat report'
    },
    {
        value: 'executive-brief-v1',
        label: 'Executive Brief'
    },
    {
        value: 'capture-review-v1',
        label: 'Capture review · 20 areas'
    },
    {
        value: 'leadership-review-v1',
        label: 'Leadership review · 8 areas'
    }
];
export const templateLabel = (id)=>templates.find((template)=>template.value === id)?.label ?? 'Unavailable template';
const labels = {
    customer_agency_names: 'Customer agencies',
    solicitation_number: 'Solicitation number',
    period_of_performance: 'Period of performance',
    opportunity_hypothesis: 'Opportunity hypothesis',
    why_evidence_supports: 'Why the evidence supports this',
    why_it_matters: 'Why it matters',
    accepted: 'Accepted for internal capture',
    approach_accepted: 'Approach accepted for internal capture',
    company_profile_id: 'Company reference',
    owner_user_id: 'Task owner',
    due_at: 'Due date',
    no_declared_gaps: 'No declared proof gaps',
    assessed: 'Current supported assessment',
    reviewed: 'Internally reviewed',
    items_json: 'Solution items',
    components_json: 'Solution components',
    assumptions_json: 'Assumptions',
    source_version: 'Pinned source version'
};
export function productLabel(key) {
    return labels[key] ?? key.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/_/g, ' ').replace(/^./, (c)=>c.toUpperCase());
}
export function readinessWhy(section) {
    // Win Themes derive their reason server-side (unsupported claims, stale lineage).
    if (section.key === 'win_themes' && section.reason) return section.reason;
    if (section.readiness === 'ready') return 'All internal content criteria are covered.';
    const missing = [
        ...new Set(section.missingCriteria.map((criterion)=>productLabel(criterion.split(': ').pop() ?? criterion)))
    ];
    return `${section.readiness === 'missing' ? 'No permitted source or manual material. Needs' : 'Missing or awaiting review'}: ${missing.join(', ') || 'source information'}.`;
}
export function ownerDestination(section) {
    if (section.owner === 'Outputs manual material') return null;
    switch(section.key){
        case 'customer_themes':
            return {
                tab: 'themes'
            };
        case 'solution':
            return {
                tab: 'solution'
            };
        case 'past_performance':
            return {
                tab: 'past-performance'
            };
        case 'customer_outreach':
            return {
                tab: 'interactions'
            };
        case 'profile':
        case 'background':
            return {
                tab: 'overview',
                anchor: 'pursuit-profile'
            };
        case 'pursuit_team':
            return {
                tab: 'overview',
                anchor: 'pursuit-team'
            };
        case 'teaming':
        case 'competition':
            return {
                tab: 'overview',
                anchor: 'pursuit-companies'
            };
        default:
            return {
                tab: 'overview',
                anchor: 'pursuit-plan'
            };
    }
}
export function dateLabel(value) {
    const date = new Date(value);
    return Number.isNaN(date.getTime()) ? 'Date unavailable' : date.toLocaleString();
}
export function accessDenied(error) {
    const code = error?.code;
    return code === 7 || code === 16 || code === 5;
}
